import posthog from 'posthog-js';
import { ANALYTICS_EVENTS, isAnalyticsEnabled } from '../config/analytics';
import { buildAcquisitionMetadata } from './acquisitionMetadata';
import { trackMetaFunnelEvent } from './metaPixel';

const SIGNUP_MARKER = 'rely_growth_signup_pending';
const SIGNUP_MARKER_VERSION = 1;
const SIGNUP_MAX_AGE_MS = 24 * 60 * 60 * 1000;
const CLOCK_SKEW_MS = 5 * 60 * 1000;

function readGrowthSignupMarker() {
  const rawMarker = localStorage.getItem(SIGNUP_MARKER);
  if (!rawMarker) return null;

  try {
    const marker = JSON.parse(rawMarker);
    const startedAt = Date.parse(marker?.startedAt);
    const now = Date.now();
    if (
      marker?.version !== SIGNUP_MARKER_VERSION ||
      !Number.isFinite(startedAt) ||
      now - startedAt > SIGNUP_MAX_AGE_MS ||
      startedAt > now + CLOCK_SKEW_MS
    ) {
      localStorage.removeItem(SIGNUP_MARKER);
      return null;
    }
    return { ...marker, startedAt };
  } catch {
    localStorage.removeItem(SIGNUP_MARKER);
    return null;
  }
}

export function trackGrowthFunnel(event, properties = {}) {
  if (!isAnalyticsEnabled()) return;
  const eventProperties = {
    ...buildAcquisitionMetadata(),
    ...properties,
    occurred_at: new Date().toISOString(),
  };
  posthog.capture(event, eventProperties);
  trackMetaFunnelEvent(event, eventProperties);
}

export function markGrowthSignupStarted() {
  if (!isAnalyticsEnabled() || readGrowthSignupMarker()) {
    return false;
  }

  const startedAt = new Date().toISOString();
  trackGrowthFunnel(ANALYTICS_EVENTS.REGISTRATION_STARTED);
  localStorage.setItem(
    SIGNUP_MARKER,
    JSON.stringify({ version: SIGNUP_MARKER_VERSION, startedAt })
  );
  return true;
}

export function hasPendingGrowthSignup() {
  return Boolean(readGrowthSignupMarker());
}

export function trackGrowthSignupCompletedIfPending(userId, registeredAt) {
  const marker = readGrowthSignupMarker();
  if (!marker) return false;

  const tenantRegisteredAt = Date.parse(registeredAt);
  const now = Date.now();
  const isFreshSignup =
    Number.isFinite(tenantRegisteredAt) &&
    now - marker.startedAt <= SIGNUP_MAX_AGE_MS &&
    tenantRegisteredAt >= marker.startedAt - CLOCK_SKEW_MS &&
    tenantRegisteredAt <= now + CLOCK_SKEW_MS;

  localStorage.removeItem(SIGNUP_MARKER);
  if (!isFreshSignup) return false;

  trackGrowthFunnel(ANALYTICS_EVENTS.REGISTRATION_COMPLETED, {
    user_id: userId,
    registration_started_at: new Date(marker.startedAt).toISOString(),
    tenant_registered_at: new Date(tenantRegisteredAt).toISOString(),
  });
  return true;
}
